import React, { Component } from 'react';
import { connect } from 'react-redux';
import MainLayout from '../../../components/Layout/MainLayout';
import MapQuyHoach from '../MapQuyHoach';
import { Button, Col, Row, Select, Table } from 'antd';
import '../quy-hoach-kien-truc.scss';
import {
  getDataPhuong,
  getDataQuan,
} from '../../../redux/actions/search.action';
import { AxiosGetSecretApi } from '../../../utils/fetchApi';
import SearchResult500 from './SearchResult500';
import Map from './Map';
import StaticClass from '../../../utils/staticClass';
export class QuyHoach500 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuAn: [],

      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuAn: undefined,

      dataTable: [],
      pagination: { pageSize: 10, total: 1, current: 1 },
      isLoading: true,
      currentIndex: null,

      dataSearch: undefined,

      isShowSearchResult: false,
      resetButton: false,
      query: '',
    };

    this.columns = [
      {
        title: 'STT',
        dataIndex: 'key',
      },
      {
        title: 'Tên dự án',
        dataIndex: 'Tendoan',
      },
      {
        title: 'Diện tích (ha)',
        dataIndex: 'DienTich',
        render: (cell, row, index) => {
          let DienTich = row.DienTich;
          return StaticClass.formatPrice(DienTich);
          // if (DienTich && !Number.isInteger(DienTich))
          //   DienTich = DienTich.toFixed(3);
          // return <div>{DienTich}</div>;
        },
      },

      {
        title: 'Quận/Huyện',
        dataIndex: 'TENHUYEN',
      },

      {
        title: 'Phường/Xã',
        dataIndex: 'TenPhuong',
      },
    ];

    this.map = React.createRef();
    this.listDuAn = [];
  }

  componentDidMount() {
    if (this.props.listQuan.length === 0) this.props.getDataQuan();
    if (this.props.listPhuong.length === 0) this.props.getDataPhuong();
    this.getDataDuAn();
    this.onSearchClick();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
    }
  }

  async getDataDuAn() {
    let res = await AxiosGetSecretApi('/api/duanqh/all');
    if (res && Array.isArray(res)) {
      this.setState({ listDuAn: res });
      this.listDuAn = res;
    }
  }

  onChangeQuan(value) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan === value);
    let listDuAn = this.listDuAn.filter((e) => e.IDHuyen === value);

    this.setState({
      selectedQuan: value,
      selectedPhuong: undefined,
      selectedDuAn: undefined,
      listPhuong: listPhuong,
      listDuAn,
    });
  }

  onChangePhuong(value, option) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan === option.idquan);

    let selectedQuan = this.state.listQuan.filter(
      (e) => e.MAHUYEN === option.idquan
    );

    let listDuAn = this.listDuAn.filter((e) => e.Maphuong === value);

    this.setState({
      selectedQuan:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
      selectedPhuong: value,
      selectedDuAn: undefined,
      listPhuong: listPhuong,
      listDuAn: listDuAn,
    });
  }

  onChangeDuAn(value, option) {
    let listPhuong = [];
    let selectedQuan = this.props.listQuan.filter(
      (e) => e.TENHUYEN === option.tenquan
    );
    if (selectedQuan.length !== 0) {
      listPhuong = this.props.listPhuong.filter(
        (e) => e.MaQuan === selectedQuan[0].MAHUYEN
      );
    }
    let selectedPhuong = this.props.listPhuong.filter(
      (e) => e.MaPhuong === option.idphuong
    );

    this.setState({
      selectedQuan:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
      selectedPhuong:
        selectedPhuong && selectedPhuong.length !== 0
          ? selectedPhuong[0].MaPhuong
          : undefined,
      listPhuong: listPhuong,
      selectedDuAn: value,
    });
  }

  onResetButton() {
    this.map.current.handleCloseClick();

    this.onSearchClick('TimMoi');
    this.setState({
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuAn: this.listDuAn,

      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuAn: undefined,

      currentIndex: null,
      isShowSearchResult: undefined,
      resetButton: !this.state.resetButton,
      dataFile: [],
    });
  }

  // table
  SetStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  handleTableChange = async (pagination) => {
    await this.SetStateAsync({ pagination });
    this.onSearchClick('pagination');
  };

  onSearchClick = async (e) => {
    this.setState({
      isLoading: true,
    });
    if (e === 'TimKiem') {
      await this.SetStateAsync({
        pagination: { pageSize: 10, total: 1, current: 1 },
        currentIndex: null,
      });
    }
    let url = '';
    let query = '';
    if (e === 'TimMoi') {
      url = `/api/duanqh/search?curPage=1&pageSize=10&`;
      this.setState({ query });
    } else {
      url = `/api/duanqh/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;

      if (this.state.selectedQuan) {
        query = query + `IDHuyen=${this.state.selectedQuan}&`;
        url = url + `IDHuyen=${this.state.selectedQuan}&`;
      }

      if (this.state.selectedPhuong) {
        query = query + `IDPhuong=${this.state.selectedPhuong}&`;
        url = url + `IDPhuong=${this.state.selectedPhuong}&`;
      }

      if (this.state.selectedDuAn) {
        let TenDuAn = encodeURIComponent(this.state.selectedDuAn);
        query = query + `TenDuAn=${TenDuAn}&`;
        url = url + `TenDuAn=${TenDuAn}&`;
      }
    }

    if (e === 'pagination') {
      url = `/api/duanqh/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;
      query = this.state.query;
      url = url + query;
    }

    if (e === 'TimKiem') {
      this.setState({ query: query });
    }

    let res = await AxiosGetSecretApi(url);
    let dataTable = [];
    if (res && res.dataResult) {
      dataTable = res.dataResult.map((o, index) => {
        return {
          ...o,
          key:
            e === 'TimMoi'
              ? index + 1
              : index +
                1 +
                (this.state.pagination.current - 1) *
                  this.state.pagination.pageSize,
        };
      });
      this.setState({
        dataTable: dataTable,
        pagination: res.dataPaginate,
        isLoading: false,
      });
    } else {
      this.setState({
        dataTable: dataTable,
        pagination: this.state.pagination,
        isLoading: false,
      });
    }
  };

  onSearchByObjectId = async (id) => {
    this.setState({ isLoading: true });

    let url = `/api/duanqh/search?curPage=1&pageSize=10&&OBJECTID=${id}`;
    let res = await AxiosGetSecretApi(url);
    let dataTable = [];

    if (res && res.dataResult) {
      dataTable = res.dataResult.map((o, index) => {
        return {
          ...o,
          stt:
            index +
            1 +
            (this.state.pagination.current - 1) *
              this.state.pagination.pageSize,
        };
      });
      if (res.dataResult.length !== 0) {
        this.getGeoData(res.dataResult[0].OBJECTID_1);
        this.getFile(res.dataResult[0].OBJECTID_1);
        this.setState({
          currentIndex: 0,
          dataSearch: res.dataResult[0],
          isShowSearchResult: 'search',
        });
      }
    }

    this.setState({
      dataTable: dataTable,
      pagination: res.dataPaginate,
      isLoading: false,
    });
  };

  onShowSearchResult = () => {
    this.setState({
      isShowSearchResult: 'search',
    });
  };

  onCloseSearchResult = () => {
    this.setState({
      isShowSearchResult: 'button',
    });
  };

  async getFile(id) {
    let res = await AxiosGetSecretApi(`/api/duanqh/getAllAsset?ID=${id}`);
    if (res && Array.isArray(res) && res.length !== 0) {
      this.setState({
        dataFile: res,
      });
    } else {
      this.setState({
        dataFile: [],
      });
    }
  }

  async getGeoData(id) {
    let res = await AxiosGetSecretApi(
      `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/7/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`
    );
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].geometry &&
      res.features[0].geometry.rings
    )
      this.map.current.drawRing(res.features[0].geometry.rings);
    // console.log(res.features[0].geometry.rings)
  }

  render() {
    return (
      <MainLayout {...this.props} title={'Quy hoạch chi tiết 1/500'}>
        <div className='quy-hoach-main'>
          <div style={{ padding: '10px' }}>
            <div className='quy-hoach'>
              <div className='quy-hoach-header'>
                Danh sách Dự án Quy hoạch chi tiết 1/500
              </div>

              <div className='quy-hoach-body'>
                <div className='search-input'>
                  <Row gutter={[20, 0]} style={{ marginBottom: '15px' }}>
                    <Col span={12}>
                      <div className='group'>
                        <div className='gr-title'>
                          <div className='text'>Quận/Huyện</div>
                        </div>

                        <div className='gr-body'>
                          <Select
                            className='select'
                            showSearch
                            value={this.state.selectedQuan}
                            onChange={(value) => this.onChangeQuan(value)}
                            optionFilterProp='name'
                          >
                            {this.state.listQuan.map((e, i) => (
                              <Select.Option
                                value={e.MAHUYEN}
                                key={i}
                                name={e.TENHUYEN}
                              >
                                {e.TENHUYEN}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </Col>

                    <Col span={12}>
                      <div className='group'>
                        <div className='gr-title'>
                          <div className='text'>Phường/Xã</div>
                        </div>

                        <div className='gr-body'>
                          <Select
                            className='select'
                            showSearch
                            onChange={(value, option) =>
                              this.onChangePhuong(value, option)
                            }
                            value={this.state.selectedPhuong}
                            optionFilterProp='name'
                          >
                            {this.state.listPhuong.map((e, i) => (
                              <Select.Option
                                value={e.MaPhuong}
                                idquan={e.MaQuan}
                                name={e.TenPhuong}
                                key={i}
                              >
                                {e.TenPhuong}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row gutter={[20, 0]} style={{ marginBottom: '15px' }}>
                    <Col span={12}>
                      <div className='group'>
                        <div className='gr-title'>
                          <div className='text'>Tên dự án</div>
                        </div>

                        <div className='gr-body'>
                          <Select
                            className='select'
                            showSearch
                            value={this.state.selectedDuAn}
                            onChange={(value, option) =>
                              this.onChangeDuAn(value, option)
                            }
                          >
                            {this.state.listDuAn.map((e, i) => (
                              <Select.Option
                                value={e.Tendoan}
                                key={i}
                                idphuong={e.Maphuong}
                                tenquan={e.TENHUYEN}
                              >
                                {e.Tendoan}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div style={{ display: 'flex' }}>
                    <Button
                      type='primary'
                      onClick={() => {
                        this.onResetButton();
                      }}
                      className='search-button'
                    >
                      Tìm mới
                    </Button>

                    <Button
                      type='primary'
                      onClick={() => this.onSearchClick('TimKiem')}
                      className='search-button'
                    >
                      Tìm kiếm
                    </Button>
                  </div>
                </div>
              </div>

              <div className='quy-hoach-footer'>
                <Table
                  columns={this.columns}
                  dataSource={this.state.dataTable}
                  locale={{ emptyText: 'Không có dữ liệu' }}
                  bordered
                  pagination={{
                    ...this.state.pagination,
                    showSizeChanger: false,
                  }}
                  onChange={this.handleTableChange}
                  size='small'
                  loading={this.state.isLoading}
                  rowKey={(record) => record.OBJECTID}
                  rowClassName={(record, index) =>
                    index +
                      (this.state.pagination.current - 1) *
                        this.state.pagination.pageSize ===
                    this.state.currentIndex
                      ? 'highlight'
                      : 'not-highlight'
                  }
                  onRow={(record, rowIndex) => {
                    return {
                      onClick: async (event) => {
                        this.getGeoData(record.OBJECTID_1);
                        this.getFile(record.OBJECTID_1);
                        this.setState({
                          currentIndex:
                            rowIndex +
                            (this.state.pagination.current - 1) *
                              this.state.pagination.pageSize,
                          dataSearch: record,

                          isShowSearchResult: 'search',
                        });
                      }, // click row
                    };
                  }}
                />
              </div>
              {this.state.isShowSearchResult === 'search' && (
                <SearchResult500
                  data={this.state.dataSearch}
                  file={this.state.dataFile}
                  close={this.onCloseSearchResult}
                ></SearchResult500>
              )}

              {/* {this.state.isShowSearchResult === "button" && (
                <Button
                  className="close-popup-result"
                  type="primary"
                  onClick={this.onShowSearchResult}
                >
                  <i className="fas fa-search"></i>
                </Button>
              )} */}
            </div>
          </div>
          <div className='quy-hoach-map'>
            {/* <MapQuyHoach
              type="QHCT"
              ref={this.map}
              isShowMenu={this.props.isShowMenu}
              searchDataTable={this.onSearchByObjectId}
              listDuAn = {this.state.listDuAn}
            ></MapQuyHoach> */}
            <Map
              type='QHCT'
              ref={this.map}
              resetButton={this.state.resetButton}
              isShowMenu={this.props.isShowMenu}
              searchDataTable={this.onSearchByObjectId}
              listDuAn={this.state.listDuAn}
            ></Map>
          </div>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    listQuan: state.search.listQuan,
    listPhuong: state.search.listPhuong,
    isShowMenu: state.menu.isShowMenu,
  };
};

const mapDispatchToProps = {
  getDataQuan: getDataQuan,
  getDataPhuong: getDataPhuong,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuyHoach500);
